import React, { useEffect } from "react";
import removeBgImage from "../Assets/hero11.png";

const Herosection = () => {
  useEffect(() => {}, []);

  return (
    <>
      <style>{`
        .section-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient(to right, #0f2027, #203a43, #2c5364);
          padding: 60px 10%;
          padding-top: 120px;
          min-height: 100vh;
          color: #fff;
          overflow: hidden;
        }

        .section-text {
          flex: 1;
          padding-right: 30px;
        }

        .section-text h2 {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #ffd700;
          text-shadow: 0 0 8px rgba(255, 215, 0, 0.6), 0 0 15px rgba(255, 215, 0, 0.3);
        }

        .section-text p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #f0f0f0;
        }

        .know-more-btn {
          margin-top: 25px;
          background: linear-gradient(to right, #00c6ff, #0072ff);
          border: none;
          padding: 12px 30px;
          color: white;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 30px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 114, 255, 0.4);
        }

        .know-more-btn:hover {
          background: linear-gradient(to right, #0072ff, #00c6ff);
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 114, 255, 0.6);
        }

        .section-image {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .section-image img {
          width: 100%;
          max-width: 450px;
          height: auto;
          object-fit: contain;
        }

        @media (max-width: 768px) {
          .section-container {
            flex-direction: column;
            padding: 40px 20px;
            padding-top: 120px;
            text-align: center;
            min-height: auto;
          }

          .section-text {
            padding-right: 0;
          }

          .section-text h2 {
            font-size: 2rem;
          }

          .section-text p {
            font-size: 0.95rem;
          }

          .section-image {
            margin-top: 30px;
          }

          .section-image img {
            max-width: 300px;
          }

          .know-more-btn {
            width: auto;
            max-width: 100%;
            font-size: 0.9rem;
            padding: 10px 25px;
          }
        }
      `}</style>

      <div className="section-container" style={{ paddingTop: "150px" }}>
        <div className="section-text" data-aos="fade-right">
          <h2>Empowering Your Business Through Expert Solutions and Strategic Support</h2>
          <p>
            At <span style={{ color: "#ffd700", fontWeight: 'bold' }}>OJASPI</span>, we provide a comprehensive suite of services strategically tailored to help businesses achieve their goals. Our core offerings include <strong>Human Resources</strong>, <strong>Equipment Recovery</strong>, <strong>Financial Services</strong>, <strong>Customer Verification</strong>, <strong>Web Solutions</strong>, and <strong>Digital Marketing</strong>. Additionally, <strong>E-commerce</strong> is our flagship product—designed and developed in-house to drive seamless digital business transformation. Our mission is to deliver innovative, effective, and elegant solutions that empower your business to succeed in today’s dynamic digital landscape.
          </p>
          <button className="know-more-btn">
            <a href="/services" style={{ textDecoration: "none", color: "white" }}>
              Discover Our Services
            </a>
          </button>
        </div>

        <div className="section-image" data-aos="fade-left">
          <img src={removeBgImage} alt="Smart Solutions" />
        </div>
      </div>
    </>
  );
};

export default Herosection;
